import { clear, unprefix } from '../../../helpers/compact';
import { toRichText, toText } from '../fields/text';
import { author } from './author';

export const audio = (data) => {
  const {
    src: { url } = {},
    alt,
    desc,
    transcription,
    title,
    ...rest
  } = unprefix('audio', data);
  if (url) {
    return clear({
      src: url,
      alt: toText(alt),
      desc: toRichText(transcription) || toText(desc),
      title: toText(title),
      author: author(rest),
    });
  }
};
